import React from "react";

import { css } from "@emotion/css";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import buttons from "../../../styles/buttons";
import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n";

const Book = () => {
  const { t } = useI18n();
  return (
    <div className={style.main}>
      <video autoPlay loop muted playsInline webkit-playsinline>
        <source
          src="/videos/book.mp4"
          type="video/mp4"
        />
      </video>
      <div className={style.container}>
        <h2>
          {t("retailers_ready1")}
          <br />
          {t("retailers_ready2")}
          <br />
          {t("retailers_ready3")}
        </h2>
          <Link
            to={"/book"}
            className={buttons.primary}
          >
            {t("retailers_book_demo")}
          </Link>
      </div>
    </div>
  );
};

const style = {
  main: css({
    height: 1024,
    position: "relative",

    video: {
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      left: 0,
      top: 0,
      zIndex: "0",
    },
    [desktop]: {
      height: 1140,
      video: {
        objectPosition: "80% 100%",
      },
    },
    [laptop]: {
      height: 1040,
    },
    [tablet]: {
      height: 527,
    },
  }),
  container: css({
    position: "absolute",
    bottom: 130,
    left: 0,
    right: 0,
    margin: "auto",
    width: "100%",
    maxWidth: 631,
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: 40,

    h2: {
      color: "#fff",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 48,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "52px",
    },
    span: {
      background: "rgba(255, 255, 255, 0.50)",
    },
    [desktop]: {
      maxWidth: 660,
      bottom: 80,
      left: 0,
      right: 0,
      margin: "auto",
      h2: {
        fontSize: 48,
        lineHeight: "52px",
      },
    },
    [laptop]: {
      bottom: 60,
      margin: "auto",
      gap: 20,
    },
    [tablet]: {
      maxWidth: 354,
      bottom: 40,
      margin: "auto",
      h2: {
        fontSize: 24,
        lineHeight: "28px",
      },
    },
  }),
};

export default Book;
